import { render, staticRenderFns } from "./centerLeft1.vue?vue&type=template&id=c96d565a&scoped=true"
import script from "./centerLeft1.vue?vue&type=script&lang=js"
export * from "./centerLeft1.vue?vue&type=script&lang=js"
import style0 from "./centerLeft1.vue?vue&type=style&index=0&id=c96d565a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96d565a",
  null
  
)

export default component.exports